export const SET_DATASET_EVALUATOR_SELECTION_TOOL_NAME =
  "set_dataset_evaluator_selection";
